import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import { useZxing } from "react-zxing";
import { callBackend } from "../components/callBackend";
import GLData from "../data/gl.json";
import EventsCatalog from "../data/events-catalog.json";
import DataTable from "../components/DataTable";

export default function Attendance({ glOrEvent }) {
	const { gl } = useParams();
	const [scanError, setScanError] = useState(null);
	const lastScanRef = useRef({ text: null, at: 0 });
	const { ref } = useZxing({
		constraints: {
			video: { facingMode: { ideal: "environment" } },
			audio: false,
		},
		timeBetweenDecodingAttempts: 300,
		onDecodeResult(result) {
			const text = result.getText();
			const now = Date.now();
			if (
				lastScanRef.current.text === text &&
				now - lastScanRef.current.at < 2000
			) {
				return;
			}
			lastScanRef.current = { text, at: now };
			const input = document.getElementsByName("pid")[0];
			if (input) input.value = text;
			glAttendance();
		},
		onError(err) {
			console.error("Scanner error:", err);
			setScanError(err?.message || String(err));
		},
	});

	const [partData, setPartData] = useState([]);

	const [tableControls, setTableControls] = useState({
		page: 1,
		length: 100,
		sortField: "_id",
		sortDir: -1,
		search: "",
	});

	const getPartData = async (event) => {
		if (!localStorage.getItem("nssc-admin-token")) {
			window.location.href = "/login";
		}

		const endpoint =
			glOrEvent === "gl"
				? "/admin/gl/" + event
				: "/admin/event/mark-attendance/" + event;

		callBackend({
			method: "GET",
			endpoint,
			onSuccess: (res) => {
				setPartData(res.data || []);
			},
		});
	};

	useEffect(() => {
		getPartData(gl);
	}, [gl]);

	const columns = {
		pid: "PID",
		name: "Name",
		college: "College/School",
	};

	const glAttendance = async () => {
		if (confirm("Are you sure you want to mark attendance?")) {
			callBackend({
				method: "POST",
				endpoint:
					glOrEvent === "gl"
						? "/admin/gl/" + gl
						: "/admin/event/mark-attendance/" + gl,
				data: {
					pid: document.getElementsByName("pid")[0].value,
				},
				onSuccess: (res) => {
					document.getElementsByName("pid")[0].value = "";
					getPartData(gl);
				},
			});
		}
	};

	return (
		<Container
			fluid
			style={{
				marginTop: "20px",
				marginBottom: "20px",
			}}
		>
			<h1 className="text-center">
				<u>
					Attendance for{" "}
					{glOrEvent === "gl"
						? GLData[gl]?.name
						: EventsCatalog[gl]?.name}
				</u>
			</h1>
			<br />
			<center>
				<div
					style={{
						gap: "10px",
						display: "flex",
						justifyContent: "center",
					}}
				>
					<input type="text" placeholder="Enter PID" name="pid" />
					<button className="btn btn-primary" onClick={glAttendance}>
						Submit
					</button>
				</div>
				<br />
				<video
					ref={ref}
					playsInline
					muted
					autoPlay
					style={{
						width: "100%",
						height: "auto",
						maxWidth: "500px",
						maxHeight: "300px",
						background: "#000",
					}}
				/>
				{scanError && (
					<div style={{ color: "red", marginTop: "8px" }}>
						Camera error: {scanError}
						<br />
						<small>
							Make sure the page is served over HTTPS, camera permission is
							granted, and no other app is using the camera.
						</small>
					</div>
				)}
				{!window.isSecureContext && (
					<div style={{ color: "orange", marginTop: "8px" }}>
						<small>
							This page is not on HTTPS — browsers block camera access on
							insecure origins (except localhost).
						</small>
					</div>
				)}
			</center>
			{(() => {
				const q = (tableControls.search || "").trim().toLowerCase();
				const searched = q
					? partData.filter((p) =>
						Object.values(p || {}).some((v) => {
							if (v === null || v === undefined) return false;
							if (typeof v === "object") {
								try {
									return JSON.stringify(v).toLowerCase().includes(q);
								} catch (e) {
									return false;
								}
							}
							return String(v).toLowerCase().includes(q);
						})
					)
					: partData;
				const start = (tableControls.page - 1) * tableControls.length;
				const pageSlice = searched.slice(start, start + tableControls.length);
				return (
					<DataTable
						columns={columns}
						data={pageSlice}
						count={searched.length}
						tableControls={tableControls}
						setTableControls={setTableControls}
					/>
				);
			})()}
		</Container>
	);
}
